import { Create, Datagrid, Edit, ImageField, List, SaveButton, SimpleForm, TextField, TextInput, Toolbar, EditButton, DeleteButton, ImageInput } from "react-admin";

export const StateList = (props) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="name" />
                <TextField source="name_en" />

                <EditButton></EditButton>
                <DeleteButton mutationMode="pessimistic" />

            </Datagrid>
        </List>
    )
}

export const StateCreate = (props) => {

    return (
        <Create {...props} dir="rtl" redirect="list">
            <SimpleForm>
                <TextInput source="name" />
                <TextInput source="name_en" />
            </SimpleForm>
        </Create>
    )
}

const UserEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);


export const StateEdit = (props) => {
    return (<Edit {...props} >
        <SimpleForm toolbar={<UserEditToolbar />}>
            <TextInput source="name" />
            <TextInput source="name_en" />
        </SimpleForm>
    </Edit>)
}


